import { graphql } from "@opensea/graphql"
import { CreateOrdersSummaryFragment } from "../../../../../components/CreateOrdersSummary/CreateOrdersSummary.fragment"
import { constructOffer_itemFragment } from "../../utils/constructOffer.fragment"
import { CreateOfferFlowTableFragment } from "../CreateOfferFlowTable/CreateOfferFlowTable.fragment"

export const CreateOfferFlowReview_itemFragment = graphql(
  `
    fragment CreateOfferFlowReview_item on Item {
      id
      ...constructOffer_item
      ...CreateOfferFlowTable
      collection {
        chain {
          identifier
          nativeCurrency {
            address
          }
          offerCurrency {
            address
            symbol
          }
        }
        ...CreateOrdersSummary
      }
    }
  `,
  [
    constructOffer_itemFragment,
    CreateOfferFlowTableFragment,
    CreateOrdersSummaryFragment,
  ],
)
